export default __webpack_public_path__ + "static/media/pg-26.0ee1c1fb.jpg";